module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allActive"
  }, [_c('el-row', {
    staticClass: "head"
  }, [_c('el-col', {
    staticStyle: {
      "padding": "2px 0",
      "background": "#33CCCC"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "span": 8,
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.2)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toAllCardListPage()
      }
    }
  }, [_c('label', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.allCardSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("所有卡号(张)")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "span": 8,
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.2)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toNormalCardListPage()
      }
    }
  }, [_c('label', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.normalCardSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("使用中(张)")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "border": "none",
      "cursor": "pointer"
    },
    attrs: {
      "span": 8,
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.2)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toActiveCardListPage()
      }
    }
  }, [_c('label', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.activeCardSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("待激活卡(张)")])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "2px 0",
      "background": "#3091F2"
    },
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "span": 8,
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.2)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toStopCardListPage()
      }
    }
  }, [_c('label', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.stopCardSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("停机卡号(张)")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "span": 8,
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.2)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toExpireCardListPage()
      }
    }
  }, [_c('label', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.expireCardSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("已到期数(张)")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "border": "none",
      "cursor": "pointer"
    },
    attrs: {
      "span": 8,
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.2)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toWarmingCardListPage()
      }
    }
  }, [_c('label', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.flowWarmingSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("流量预警(张)")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "head"
  }, [_c('el-col', {
    staticStyle: {
      "padding": "0px 0",
      "background": "#33CCCC",
      "cursor": "pointer",
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [(_vm.todoOutGprsTotal > 0) ? _c('div', {
    staticClass: "nav-counter nav-counter-blue",
    staticStyle: {
      "display": "block",
      "position": "relative",
      "z-index": "1"
    }
  }, [_vm._v(_vm._s(_vm.todoOutGprsTotalStr))]) : _vm._e(), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "span": 24,
      "element-loading-spinner": "el-icon-loading"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toDataStopPage()
      }
    }
  }, [(_vm.todoOutGprsTotal > 0) ? _c('div', {
    staticClass: "iconfont icon-daichuli",
    staticStyle: {
      "display": "block",
      "position": "relative",
      "float": "right",
      "right": "0px",
      "top": "-30px",
      "font-size": "40px",
      "z-index": "0"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.dataStopCardSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("数据达量停机(张)")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.gprsStatVisible),
      expression: "gprsStatVisible"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyGprs,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "apiname",
      "label": "集团客户名称",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usernum",
      "label": "流量池用户数(个)",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalgprs",
      "label": "流量池总流量(MB)",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usedgprs",
      "label": "已使用的流量(MB)",
      "min-width": "180",
      "sortable": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-2df92748!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 735
// module chunks = 2